import React from 'react';

interface Submission {
  id: number;
  title: string;
  link: string;
  description?: string;
  created_at: string;
}

interface SubmissionsListProps {
  submissions: Submission[];
}

const SubmissionsList: React.FC<SubmissionsListProps> = ({ submissions }) => {
  if (submissions.length === 0) {
    return (
      <div className="text-xs font-mono text-neutral-500">
        no submissions yet
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {submissions.map((submission) => (
        <div
          key={submission.id}
          className="border-b border-neutral-200 pb-3 last:border-0"
        >
          <div className="font-mono text-sm text-neutral-900">
            {submission.title}
          </div>
          {submission.description && (
            <p className="text-xs font-mono text-neutral-500 mt-1">
              {submission.description}
            </p>
          )}
          <div className="flex items-center gap-4 mt-2">
            <a
              href={submission.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs font-mono text-neutral-700 underline"
            >
              view →
            </a>
            <span className="text-xs font-mono text-neutral-400">
              {new Date(submission.created_at).toLocaleString('en-US', {
                month: 'numeric',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
              })}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SubmissionsList;